import type { SourceSummary } from '../services/api';

export type ActiveCollectorAgency = {
  key: string;
  name: string;
  level?: string | null;
  uf?: string | null;
  municipality?: string | null;
  total_normas: number;
};

/** Agências com normas monitoradas no BD (dados já coletados por BOT/API/scraping). */
export function pickAgenciesWithCollectedData(summaries: SourceSummary[]): ActiveCollectorAgency[] {
  return summaries
    .filter((s) => (s.total_normas ?? 0) > 0)
    .map((s) => ({
      key: s.key,
      name: s.name,
      level: s.level,
      uf: s.uf,
      municipality: s.municipality,
      total_normas: s.total_normas,
    }))
    .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
}

export function mergeActiveCollectorAgencies(...scopes: SourceSummary[][]): ActiveCollectorAgency[] {
  const byKey = new Map<string, ActiveCollectorAgency>();
  for (const scope of scopes) {
    for (const agency of pickAgenciesWithCollectedData(scope)) {
      if (!byKey.has(agency.key)) byKey.set(agency.key, agency);
    }
  }
  return Array.from(byKey.values()).sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
}
